import MonitoringVisitLog from './MonitoringVisitLog'
import CosmosJobsDbRecordBase from '../CosmosJobsDbRecordBase'

export default class MonitoringDetail extends CosmosJobsDbRecordBase {
  public plannedVisitCount: number
  public visitFrequency: number
  public monitoringVisitLogs: MonitoringVisitLog[]
}
